module.exports = __webpack_public_path__ + "images/no-hotel-photo-available.8c9c4f6.gif";